<script lang="ts">
  import PageTitle from '$lib/teach/resources/PageTitle.svelte';

  // import RhythmSpan from 'exercises/src/uTheory.Notation/RhythmSpan.svelte';
  import SpiceDemo from 'exercises/src/uTheory.Notation/pitch-detection/SpiceDemo.svelte';
</script>

<PageTitle
  title="SPICE/Tensorflow Pitch Detection"
  description="Demonstration of real-time pitch analysis using the SPICE
  machine learning algorithm from Google."
/>

<div class=" max-w-xl">
  <!-- <RhythmSpan timeSignatures={['2/4']} rhythmString="2/4: q e e" /> -->
  <SpiceDemo />
</div>
